import {createStore, is} from '@effector/effector'
import {Grid} from '../graph/deps/pathfinding'

import {nodes$} from '../workingSet'
import {
  BLOCK_WIDTH,
  BLOCK_HEIGHT,
  FULL_WIDTH,
  FULL_HEIGHT,
  MATRIX_CELL_AMOUNT_ROW,
  BLOCK_AMOUNT_IN_ROW
} from './env'

function posFromBlockIndex(index: number): [number, number] {
  const x = index % BLOCK_AMOUNT_IN_ROW
  const y = (index - x) / BLOCK_AMOUNT_IN_ROW
  return [x, y]
}

export const filteredNodes = nodes$.map(nodes =>
  nodes.filter(node => {
    if (node.exclude) return false
    return true
  })
)

export const blockList = filteredNodes.map(nodes =>
  nodes.map((node, i) => {
    const [x, y] = posFromBlockIndex(i)
    const cellX = x * FULL_WIDTH + 1
    const cellY = y * FULL_HEIGHT + 1
    return {
      key: node.id,
      node,
      x,
      y,
      cell: {x: cellX, y: cellY}
    }
  })
)

const fieldHeightInBlocks = createStore(1).on(blockList, (height, blocks) => {
  const yMax = Math.max(...blocks.map(({cell: {y}}) => y))
  if (height < yMax + 1) return yMax + 1
})

export const fieldHeightInCells = fieldHeightInBlocks.map(
  height => 1 + height * FULL_HEIGHT
)

const weightsMatrix = fieldHeightInCells.map(amount =>
  Array.from({length: amount}, () => Array(MATRIX_CELL_AMOUNT_ROW).fill(0))
)

export const pathfinderGrid = weightsMatrix.map(matrix => new Grid(matrix))

//NOTE remove .on from mapped store
weightsMatrix.on(blockList, (matrix, blocks) => {
  matrix = matrix.map(row => [...row])
  for (const block of blocks) {
    const {x: cellX, y: cellY} = block.cell
    for (let y = cellY; y < cellY + BLOCK_HEIGHT && y < matrix.length; y++) {
      for (
        let x = cellX;
        x < cellX + BLOCK_WIDTH && x < MATRIX_CELL_AMOUNT_ROW;
        x++
      ) {
        matrix[y][x] = 1
      }
    }
    if (matrix.length <= cellY + 1) {
      for (let i = matrix.length; i <= cellY + 1; i++) {
        matrix[i] = Array(MATRIX_CELL_AMOUNT_ROW).fill(1)
      }
    }
    matrix[cellY + 1][cellX] = 0
    matrix[cellY + 1][cellX + BLOCK_WIDTH - 1] = 0
  }
  return matrix
})
